import { render, staticRenderFns } from "./EditReferenceIndex.vue?vue&type=template&id=5ecf9e09&"
import script from "./EditReferenceIndex.vue?vue&type=script&lang=js&"
export * from "./EditReferenceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports